import { Record, Static } from "runtypes";
import { UserRunType,UserEmailType } from "./IUser";

export const LoginCallbackResponseRuntype = Record({
  user: UserRunType,
  data:UserEmailType
});

export interface ILoginCallbackResponse
  extends Static<typeof LoginCallbackResponseRuntype> {}




// WEBPACK FOOTER //
// ./src/api/types/ILoginCallbackResponse.ts